import {useTranslation} from "react-i18next";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {useState} from "react";
import {activatePromoCode} from "./api/paymentApi";

export default function PromoCode() {
    const { t } = useTranslation();
    const [promoError, setPromoError] = useState(false);
    const schema = yup.object().shape({
        promoCode: yup.string()
            .required(t('login.errors.required'))
    });
    const {register, handleSubmit, watch, errors} = useForm(
        {
            resolver: yupResolver(schema),
            mode: 'onBlur',
            reValidateMode: 'onBlur',
        }
    );

    const onSubmit = (data) => {
        setPromoError(false);
        activatePromoCode(data.promoCode, (result) => {
            if (result.data && result.data.success) {
                window.location.reload();
            } else {
                setPromoError(true);
            }
        })
    }
    const hasErrors = promoError || errors.promoCode;

    return (
        <div className="promo activate">
            <form onSubmit={handleSubmit(onSubmit)} method="POST" className="promo-code-form">
                <div className="wrap">
                    <div className="flex-baseline">
                        <div>
                            <h6>{ t('app.promoCode.enterPromo') }</h6>
                            <input type="text" name="promoCode" placeholder="XX-XX-XX-XX" ref={register}
                                   className="form-input js-promo-code"/>
                        </div>
                        <div className="right-align">
                            <button type="submit"
                                    className="btn">{ t('app.promoCode.activate') }</button>
                        </div>
                    </div>
                </div>
                <div className="error-block">
                    {
                        hasErrors &&
                        <div className="promo-code-error">
                            { !errors.promoCode && promoError && t('app.promoCode.alreadyActivated') }
                            { !!errors.promoCode && errors.promoCode.message}
                        </div>
                    }
                </div>
            </form>
        </div>
    )
}
